import { defineComponent } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "GreenScreenIndex",
  setup: function setup() {
    var router = useRouter();

    function changeStyle() {
      router.push('/redScreens');
    }

    return {
      changeStyle: changeStyle
    };
  }
});